// Packages
import { Route, Switch, useHistory } from "react-router-dom";

// Hooks
import { useOnScrollNavAnimation } from "./Hooks/NavbarScrollHook";
// All Routes
import { routes } from "./routes";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";

import React, { useEffect } from "react";
// Styles
import "./App.css";
import SuccessDialog from "./component/schoolAdminPortal/Popups/SuccessDialog";
import { useDispatch, useSelector } from "react-redux";
import {
  closeSuccessPopup,
  closeRenamePopup,
  closeConfirmationPopup,
  closeVideoPopup,
  closeFailDialog,
} from "./Redux/Actions/PopupActions";
import RenameDialog from "./component/schoolAdminPortal/Popups/RenamePopup";
import ConfirmationDialog from "./component/schoolAdminPortal/Popups/ConfirmationDialog";
import VideoPopup from "./component/schoolAdminPortal/Popups/VideoPopup";
import FailDialog from "./component/schoolAdminPortal/Popups/FailDialog";
import PageNotFoundPage from "./Common/PageNotFoundPage";
import { Spinner } from "./component";
import InactivityTracker from "./Common/InactivityTracker";
import {
  setDrawerOpen,
  setIsMobileDevice,
} from "./Redux/Actions/SchoolAdminDashboardAction";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const successPopupData = useSelector(
    (state) => state.popupInformation.successPopUp
  );

  const failDialogData = useSelector(
    (state) => state.popupInformation.failDialog
  );

  const renamePopup = useSelector(
    (state) => state.popupInformation.renamePopup
  );

  const disableScreen = useSelector(
    (state) => state.schoolAdminDashboardInformation.disableScreen
  );

  const videoPopup = useSelector((state) => state.popupInformation.videoPopup);

  const confirmationPopup = useSelector(
    (state) => state.popupInformation.confirmationPopup
  );

  const fullPageLoading = useSelector(
    (state) => state?.LoadingData?.fullPageLoading
  );

  const closeSuccessDialog = () => {
    if (successPopupData?.navigationLink) {
      history.push(successPopupData?.navigationLink);
    }
    closeSuccessPopup(dispatch, false);
  };

  const closeVideoDialog = () => {
    closeVideoPopup(dispatch, false);
  };

  const closeRenameDialog = () => {
    closeRenamePopup(dispatch, false);
  };

  const closeConfirmationDialog = () => {
    closeConfirmationPopup(dispatch, false);
  };

  const closeFailPopup = () => {
    closeFailDialog(dispatch, false);
  };

  useEffect(() => {
    if (isMobile) {
      setIsMobileDevice(dispatch, isMobile);
      setDrawerOpen(dispatch, isMobile);
    }
  }, [isMobile]);

  return (
    <div className="App">
      {disableScreen && <div className="overlay"></div>}
      <Switch>
        {routes.map(
          ({ component, exact, path, isProtected, addHeaderFooter }, index) =>
            isProtected ? (
              <PrivateRoute
                exact={exact}
                path={path}
                key={index}
                component={component}
              />
            ) : (
              <PublicRoute
                exact={exact}
                path={path}
                key={index}
                component={component}
                addHeaderFooter={addHeaderFooter || false}
              />
            )
        )}
        <Route path="*" render={() => <PageNotFoundPage />} />
      </Switch>

      {successPopupData?.open && (
        <SuccessDialog
          successPopUp={successPopupData?.open}
          toggleSuccessDialog={closeSuccessDialog}
          msg={successPopupData?.message}
          isWarningPopUp={successPopupData?.isWarningPopUp}
        />
      )}

      {renamePopup?.open && (
        <RenameDialog
          successPopUp={renamePopup?.open}
          toggleRenameDialog={closeRenameDialog}
          videoData={renamePopup?.videoData}
          isLoading={renamePopup?.loading}
          fieldToShow={renamePopup?.fieldToShow}
        />
      )}
      <InactivityTracker />

      {confirmationPopup?.open && (
        <ConfirmationDialog
          confirmPopUp={confirmationPopup?.open}
          toggleConfirmDialog={closeConfirmationDialog}
          btnColor={confirmationPopup?.btnColor}
          btnText={confirmationPopup?.btnText}
          msg={confirmationPopup?.message}
          icon={confirmationPopup?.icon}
          messageDialog={confirmationPopup?.messageDialog}
        />
      )}

      {videoPopup?.open && (
        <VideoPopup
          successPopUp={videoPopup?.open}
          closeSuccessDialog={closeVideoDialog}
          videoUrl={videoPopup?.videoURL}
        />
      )}

      {failDialogData?.open && (
        <FailDialog
          open={failDialogData?.open}
          closeFailDialog={closeFailPopup}
          msg={failDialogData?.message}
        />
      )}
      <Spinner animate={fullPageLoading} />
    </div>
  );
}

export default App;
